export default class CurrentUserService {
  user;

  get accessibleRoutes() {
    return this.user.routes;
  }
}
